<servicerapport-accordion-panel [formGroup]="formGroup"
  [title]="'Ejendomsfaktorer'">
  @if (ejendomsfaktorer.length) {
    <mat-accordion>
      @for (ejendomsfaktor of ejendomsfaktorer; track ejendomsfaktor; let i = $index) {
        <mat-expansion-panel #panel>
          <mat-expansion-panel-header>
            <accordion-status-indicator [formGroup]="ejendomsfaktor"></accordion-status-indicator>
            <mat-panel-title>{{hentEjendomsfaktorDefinition(ejendomsfaktor.getRawValue())?.navn}}</mat-panel-title>
            <mat-panel-description>{{hentEjendomsfaktorVaerdi(ejendomsfaktor.getRawValue())}}</mat-panel-description>
          </mat-expansion-panel-header>
          <ejendomsfaktor [formGroup]="ejendomsfaktor"></ejendomsfaktor>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }

</servicerapport-accordion-panel>
